import React from 'react';
import { Layout } from 'antd';
import { GithubOutlined, LinkedinOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import './Footer.css';

const { Footer: AntFooter } = Layout;

const Footer = () => {
  return (
    <AntFooter className="app-footer">
      <div className="footer-container">
        <div className="footer-left">
          {/* Contact Information */}
          <div className="contact-section">
            <h3 className="contact-title">Get In Touch</h3>
            <div className="contact-items">
              <div className="contact-item">
                <PhoneOutlined className="contact-icon" />
                <a href="tel:+610493708199" className="contact-link">+61 0493708199</a>
              </div>
              <div className="contact-item">
                <MailOutlined className="contact-icon" />
                <a href="mailto:lucas.m.xing@gmail.com" className="contact-link">lucas.m.xing@gmail.com</a>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="copyright">
            © 2025 Personal Portfolio. All rights reserved.
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="footer-right">
          <div className="social-icons">
            <a href="https://github.com/lucas-shuoming" target="_blank" rel="noopener noreferrer" className="social-icon">
              <GithubOutlined />
            </a>
            <a href="https://www.linkedin.com/in/lucas-xing" target="_blank" rel="noopener noreferrer" className="social-icon">
              <LinkedinOutlined />
            </a>
            <a href="mailto:lucas.m.xing@gmail.com" className="social-icon">
              <MailOutlined />
            </a>
          </div>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;


